// Module
var code = "<div class=\"html-element\"> <!-- ko template: {name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data)} --><!-- /ko --> </div>";
// Exports
export default code;